module.exports = __webpack_public_path__ + "img/icon-trash.4c6120b8.svg";